var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplicationBtnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.5C6.27614 6.5 6.5 6.72386 6.5 7V8.5H8C8.27614 8.5 8.5 8.72386 8.5 9C8.5 9.27614 8.27614 9.5 8 9.5H6.5V11C6.5 11.2761 6.27614 11.5 6 11.5C5.72386 11.5 5.5 11.2761 5.5 11V9.5H4C3.72386 9.5 3.5 9.27614 3.5 9C3.5 8.72386 3.72386 8.5 4 8.5H5.5V7C5.5 6.72386 5.72386 6.5 6 6.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.5V14C12 15.1046 11.1046 16 10 16H2C0.895431 16 0 15.1046 0 14V2C0 0.89543 0.895431 0 2 0H7.5L12 4.5ZM9 4.5C8.17157 4.5 7.5 3.82843 7.5 3V1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H10C10.5523 15 11 14.5523 11 14V4.5H9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationBtnIcon);
export default __webpack_public_path__ + "static/media/application-btn-icon.297a1b80e8de584878ba99851504a464.svg";
export { ForwardRef as ReactComponent };